import { toast } from 'react-toastify';

import { capitalize } from './helpers';

import { MESSAGES } from '@/constants';

export const handleApiError = (error: any): void => {
  if (!error) return;

  const data = error?.response?.data;

  const isValidErrorMessage = (msg: unknown): boolean => {
    if (typeof msg !== 'string') return false;
    if (msg.trim() === '') return false;
    return true;
  };

  const capitalizeWord = (text: string) => capitalize(text);

  // 1. Handle Backend API errors (Axios)
  if (Array.isArray(data?.errors)) {
    const validErrors = data.errors.filter((e: any) =>
      isValidErrorMessage(typeof e === 'string' ? e : e?.msg || e?.message)
    );

    if (validErrors.length > 0) {
      validErrors.forEach((message: any) => {
        const errorMsg =
          typeof message === 'string'
            ? message
            : message.msg || message.message || JSON.stringify(message);
        toast.error(capitalizeWord(errorMsg));
      });
      return;
    }
  }

  if (data?.errors && typeof data.errors === 'object') {
    const errorMessages = Object.values(data.errors)
      .filter((msg) => isValidErrorMessage(typeof msg === 'string' ? msg : (msg as any)?.msg))
      .map((msg) => {
        const errorMsg =
          typeof msg === 'string' ? msg : (msg as any).msg || (msg as any).message || '';
        return capitalizeWord(errorMsg);
      });

    if (errorMessages.length > 0) {
      errorMessages.forEach((msg) => toast.error(msg));
      return;
    }
  }

  if (isValidErrorMessage(data?.message)) {
    toast.error(capitalizeWord(data.message));
    return;
  }

  if (isValidErrorMessage(error?.message)) {
    toast.error(capitalizeWord(error.message));
    return;
  }

  toast.error(capitalizeWord(MESSAGES.GENERAL.SOMETHING_WENT_WRONG));
};
